module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.b75e299d.svg";